import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment  } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScanCvService {
  mainURL = 'api/';
  constructor(private http: HttpClient) { }

  scanCv(cv: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'scan-cv', cv);
  }

  scanLinkedInProfile(cv: any) {
    return this.http.post(environment.apiUrl + this.mainURL + 'scan-linkedin', cv);
  }
}
